<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      eager
      persistent
      scrollable
      max-width="900px"
    >
      <v-card>
        <v-card-title dark class="dialog-header">
          <div class="dialog-header-content">
            <div class="dialog-title-wrapper">
              <div class="dialog-icon">
                <icon name="global-icon" />
              </div>

              <div class="dialog-text">
                <div class="dialog-title">
                  Office Performance Commitment and Review (OPCR)
                </div>

                <div class="dialog-subtitle">
                  Manage office performance targets, accomplishments, and
                  evaluation outcomes for the review period.
                </div>
              </div>
            </div>

            <v-btn icon class="close-btn" @click="closeD()">
              <icon name="circle-close" />
            </v-btn>
          </div>
        </v-card-title>

        <v-card-text style="max-height: 700px" class="my-4">
          <v-row>
            <v-col cols="12" v-if="isSubmitted">
              <v-stepper alt-labels class="elevation-0">
                <v-stepper-header>
                  <v-stepper-step
                    step="1"
                    class="pa-5"
                    :complete="assessed_by_status == 2 ? true : false"
                    :rules="[() => assessed_by_status != 3]"
                    color="#6DB249"
                  >
                    {{ assessed_by }}
                    <small>Assessed By<br /> </small>
                  </v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step
                    step="2"
                    class="pa-5"
                    :complete="final_rating_by_status == 2 ? true : false"
                    :rules="[() => final_rating_by_status != 3]"
                    color="#6DB249"
                  >
                    {{ final_rating_by }}
                    <small>Final Rating <br /> </small>
                  </v-stepper-step>
                </v-stepper-header>
              </v-stepper>
            </v-col>
            <v-col cols="8" class="flex-items mt-2">
              <v-tabs v-model="activeTab" color="#519043" align-tabs="left">
                <v-tab
                  v-for="tab in tabList"
                  :key="tab.id"
                  @click="changeTab(tab)"
                  >{{ tab.name }}</v-tab
                >
              </v-tabs>
            </v-col>
            <v-spacer></v-spacer>

            <v-col cols="12" class="pt-2 px-4">
              <table v-if="tab != 4" id="ipcrTable">
                <tr>
                  <td
                    colspan="3"
                    style="width: 20%"
                    rowspan="2"
                    class="font-weight-bold text-caption"
                    align="center"
                  >
                    Major Final Output(MFO)
                  </td>
                  <td
                    style="width: 20%"
                    rowspan="2"
                    class="font-weight-bold text-caption"
                    align="center"
                  >
                    Success Indicators<br />Target + Measure
                  </td>
                  <td
                    style="width: 5%"
                    rowspan="2"
                    class="font-weight-bold text-caption"
                    align="center"
                  >
                    Alloted Budget
                  </td>
                  <td
                    style="width: 20%"
                    rowspan="2"
                    class="font-weight-bold text-caption"
                    align="center"
                  >
                    Actual Accomplishments
                  </td>
                  <td
                    style="width: 20%"
                    colspan="4"
                    class="font-weight-bold text-caption"
                    align="center"
                  >
                    Rating
                  </td>
                  <td
                    style="width: 20%"
                    rowspan="2"
                    class="font-weight-bold text-caption"
                    align="center"
                  >
                    Remarks
                  </td>
                  <td
                    v-if="isEditing && (tab == 1 || tab == 2)"
                    rowspan="2"
                    class="font-weight-bold text-caption"
                    align="center"
                  >
                    Action
                  </td>
                </tr>
                <tr>
                  <td
                    style="width: 3%"
                    class="font-weight-bold text-caption"
                    align="center"
                  >
                    E
                  </td>
                  <td
                    style="width: 3%"
                    class="font-weight-bold text-caption"
                    align="center"
                  >
                    Q
                  </td>
                  <td
                    style="width: 3%"
                    class="font-weight-bold text-caption"
                    align="center"
                  >
                    T
                  </td>
                  <td
                    style="width: 3%"
                    class="font-weight-bold text-caption"
                    align="center"
                  >
                    A
                  </td>
                </tr>
                <tr style="background-color: grey" class="white--text">
                  <td class="pa-1">CODE</td>
                  <td class="pa-1" colspan="2" style="border-right: none">
                    {{
                      tab == 1
                        ? "CORE FUNCTION"
                        : tab == 2
                        ? "STRATEGIC PRIORITY"
                        : "SUPPORT FUNCTION"
                    }}
                  </td>
                  <td
                    :colspan="isEditing ? 9 : 8"
                    style="border-left: none"
                  ></td>

                  <!-- <td colspan="10">CORE FUNCTION</td> -->
                </tr>
                <tbody v-show="tab == 1 || tab == 2">
                  <tr v-for="(item, i) in tab == 1 ? cf : sp" :key="i">
                    <td
                      style="width: 5%"
                      class="text-caption pa-1"
                      align="center"
                    >
                      {{ tab == 2 ? item.code : null }}
                    </td>
                    <td
                      style="width: 5%"
                      class="text-caption pa-1"
                      align="center"
                    >
                      {{ tab == 1 ? "CF" + (i + 1) : "SP" + (i + 1) }}
                    </td>
                    <td
                      style="width: 20%"
                      class="text-caption pa-1"
                      align="left"
                    >
                      {{ item.mfo }}
                    </td>
                    <td
                      style="width: 20%"
                      class="text-caption pa-1"
                      align="left"
                    >
                      {{ item.success_indicator }}
                    </td>
                    <td
                      style="width: 5%"
                      class="text-caption pa-1"
                      align="center"
                    >
                      {{ tab == 2 ? formatPrice(item.alloted_budget) : null }}
                    </td>
                    <td
                      style="width: 20%"
                      class="text-caption pa-1"
                      align="left"
                    >
                      {{ item.actual_accomplishment }}
                    </td>
                    <td
                      style="width: 2%"
                      class="text-caption pa-1"
                      align="center"
                    >
                      {{ item.efficiency_rate }}
                    </td>
                    <td
                      style="width: 2%"
                      class="text-caption pa-1"
                      align="center"
                    >
                      {{ item.qly_rate }}
                    </td>
                    <td
                      style="width: 2%"
                      class="text-caption pa-1"
                      align="center"
                    >
                      {{ item.timeliness_rate }}
                    </td>
                    <td
                      style="width: 2%"
                      class="text-caption pa-1"
                      align="center"
                    >
                      {{ getCFSP_Avg(item) }}
                    </td>
                    <td
                      style="width: 17%"
                      class="text-caption pa-1 text-justify"
                      align="left"
                    >
                      {{ item.remarks }}
                    </td>
                    <td v-if="isEditing" class="pa-3">
                      <v-btn
                        @click="updateValue(tab, item)"
                        x-small
                        color="warning"
                        class="white--text"
                      >
                        <v-icon size="12">mdi-pencil</v-icon>
                        Edit
                      </v-btn>
                    </td>
                  </tr>
                  <tr colspan="9">
                    <td colspan="9" align="right">
                      <div class="font-weight-bold pa-2">
                        Total
                        {{ tab == 1 ? "Core Function" : "Strategic Priority" }}
                      </div>
                    </td>
                    <td align="center" class="text-caption pa-1">
                      {{ tab == 1 ? getTotalCF : getTotalSP }}
                    </td>
                    <td></td>
                  </tr>
                </tbody>
                <tbody v-show="tab == 3">
                  <tr v-for="(item, i) in sf" :key="i">
                    <td
                      style="width: 10%"
                      class="text-caption pa-1"
                      align="center"
                    >
                      {{ "SF" + (i + 1) }}
                    </td>
                    <td
                      style="width: 20%"
                      colspan="2"
                      class="text-caption pa-1"
                      align="left"
                    >
                      {{ item.mfo }}
                    </td>
                    <td
                      style="width: 20%"
                      class="text-caption pa-1"
                      align="left"
                    >
                      {{ item.success_indicator }}
                    </td>
                    <td
                      style="width: 5%"
                      class="text-caption pa-1"
                      align="left"
                    ></td>
                    <td
                      style="width: 20%"
                      class="text-caption pa-1"
                      align="left"
                    >
                      <!-- {{ item.actual_accomplishment }} -->
                    </td>
                    <td
                      style="width: 3%"
                      class="text-caption pa-1"
                      align="center"
                    >
                      {{ item.eff_is_rated ? item.efficiency : "NR" }}
                    </td>
                    <td
                      style="width: 3%"
                      class="text-caption pa-1"
                      align="center"
                    >
                      {{ item.qly_is_rated ? item.quality : "NR" }}
                    </td>
                    <td
                      style="width: 3%"
                      class="text-caption pa-1"
                      align="center"
                    >
                      {{ item.timeliness_is_rated ? item.timeliness : "NR" }}
                    </td>
                    <td
                      style="width: 3%"
                      class="text-caption pa-1"
                      align="center"
                    >
                      {{ getSFAvg(item) }}
                    </td>
                    <td
                      style="width: 13%"
                      class="text-caption pa-1"
                      align="left"
                    ></td>
                  </tr>
                  <tr colspan="9">
                    <td colspan="9" align="right">
                      <div class="font-weight-bold pa-2">
                        Total Support Function
                      </div>
                    </td>
                    <td align="center" class="text-caption pa-1">
                      {{ getTotalSF }}
                    </td>
                    <td></td>
                  </tr>
                </tbody>
              </table>

              <table v-else id="categoryTable">
                <tr>
                  <td
                    style="width: 30%"
                    class="font-weight-bold text-caption pa-1"
                    align="center"
                  >
                    Category
                  </td>
                  <td
                    style="width: 30%"
                    class="font-weight-bold text-caption"
                    align="center"
                  >
                    MFO
                  </td>
                  <td
                    style="width: 40%"
                    class="font-weight-bold text-caption"
                    align="center"
                  >
                    RATING
                  </td>
                </tr>
                <tr>
                  <td class="text-caption pa-1" align="left">Core Functions</td>
                  <td class="text-caption pa-1" align="center">
                    {{ getCFLength }}
                  </td>
                  <td class="text-caption pa-1" align="center">
                    <strong class="mr-2">{{
                      (getTotalCF * 0.6).toFixed(2)
                    }}</strong>

                    <span
                      ><i>({{ getTotalCF }} * 60%)</i></span
                    >
                  </td>
                </tr>
                <tr>
                  <td class="text-caption pa-1" align="left">
                    Strategic Priority
                  </td>
                  <td class="text-caption pa-1" align="center">
                    {{ getSPLength }}
                  </td>
                  <td class="text-caption pa-1" align="center">
                    <strong class="mr-2">
                      {{ (getTotalSP * 0.3).toFixed(2) }}</strong
                    >

                    <span
                      ><i>({{ getTotalSP }} * 30%)</i></span
                    >
                  </td>
                </tr>
                <tr>
                  <td class="text-caption pa-1" align="left">
                    Support Functions
                  </td>
                  <td class="text-caption pa-1" align="center">
                    {{ getSFLength }}
                  </td>
                  <td class="text-caption pa-1" align="center">
                    <strong class="mr-2">
                      {{ (getTotalSF * 0.1).toFixed(2) }}</strong
                    >

                    <span
                      ><i>({{ getTotalSF }} * 10%)</i></span
                    >
                  </td>
                </tr>
                <tr>
                  <td class="text-caption pa-1" align="left">
                    Total/Final Overall Rating
                  </td>
                  <td class="text-caption pa-1" align="center"></td>
                  <td class="text-caption pa-1" align="center">
                    {{
                      (
                        getTotalCF * 0.6 +
                        getTotalSP * 0.3 +
                        getTotalSF * 0.1
                      ).toFixed(2)
                    }}
                  </td>
                </tr>
                <tr>
                  <td class="text-caption pa-1" align="left">
                    Final Average Rating (by PMT)
                  </td>
                  <td class="text-caption pa-1" align="center"></td>
                  <td class="text-caption pa-1" align="center"></td>
                </tr>
              </table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-5">
          <v-fab-transition v-if="isSubmitted">
            <v-menu top>
              <template v-slot:activator="{ on }">
                <v-btn color="#519043" left outlined v-on="on"> Remarks </v-btn>
              </template>

              <v-card class="mx-auto" width="600" max-width="600" elevation-4>
                <v-card-title class="dialog-header white--text">
                  <span class="text-h6">Remarks</span>
                </v-card-title>
                <v-card-text
                  class="py-0"
                  style="
                    background-color: white;
                    height: 300px;
                    overflow-y: auto;
                  "
                >
                  <v-timeline dense v-if="remarksData.length > 0">
                    <v-timeline-item
                      v-for="item in remarksData"
                      :key="item.id"
                      small
                      color="#519043"
                      icon="mdi-comment-processing-outline"
                      fill-dot
                    >
                      <v-alert :value="true">
                        <div class="text-h6">
                          {{
                            $store.getters.getUserData.id ==
                            item.remarks_maker_userID
                              ? "You"
                              : item.remarks_by
                          }}
                        </div>
                        <div class="text-body-1">
                          {{ item.message }}
                        </div>
                        <div class="text-caption">
                          <i>{{ formatDate(item.created_at) }}</i>
                        </div>
                      </v-alert>
                    </v-timeline-item>
                  </v-timeline>
                  <v-timeline dense v-if="remarksData.length == 0">
                    <v-timeline-item
                      small
                      color="#519043"
                      icon="mdi-comment-processing-outline"
                      fill-dot
                    >
                      <v-alert :value="true">
                        <div class="text-body-1">No remarks found.</div>
                      </v-alert>
                    </v-timeline-item>
                  </v-timeline>
                </v-card-text>
              </v-card>
            </v-menu>
          </v-fab-transition>

          <v-btn class="btn-print" outlined @click="printOPCR()"> Print </v-btn>
          <v-spacer></v-spacer>

          <v-btn
            class="btn-cancel"
            outlined
            @click="closeD()"
            v-if="!isEditing"
          >
            Close
          </v-btn>

          <!-- <v-btn
            color="#519043"
            class="white--text"
            v-if="!isEditing"
            @click="isEditing = true"
          >
            <v-icon>mdi-check-circle</v-icon>
            Edit
          </v-btn> -->

          <v-btn
            v-if="isEditing"
            color="red"
            outlined
            class="white--text"
            @click="isEditing = false"
          >
            <v-icon>mdi-close-circle-outline</v-icon>
            Close Edit
          </v-btn>

          <!-- <v-btn
            color="#519043"
            class="white--text"
            v-if="!isSubmitted || getIsPendingByApprovers"
            @click="submitIPCR()"
          >
            <v-icon>mdi-check-circle</v-icon>
            Submit
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- delete dialog -->
    <v-dialog v-model="confirmDialog" persistent max-width="390">
      <v-card color="white">
        <div class="pa-4 #3a3b3a--text">
          <div class="text-h6 mb-1">WARNING!</div>
          <div class="text-body-1 mb-1">
            <p style="text-align: justify">
              <v-icon class="mt-n2" color="white">mdi-alert</v-icon> &nbsp; Are
              you sure you want to delete this information?<br /><br />
              Please note that
              <b>this action is irreversible.</b>
            </p>
          </div>
        </div>

        <!-- <v-card-title class="text-h5">
            Are you sure you want to proceed?
          </v-card-title> -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="cancelDelete()"> Close </v-btn>
          <v-btn
            :disabled="isButtonLoading"
            :loading="isButtonLoading"
            color="green"
            class="white--text"
            @click="confirmDelete()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmSubmitDialog" persistent max-width="390">
      <v-card color="white">
        <div class="pa-4 #3a3b3a--text">
          <div class="text-h6 mb-1">WARNING!</div>
          <div class="text-body-1 mb-1">
            <p style="text-align: justify">
              <v-icon class="mt-n2" color="white">mdi-alert</v-icon> &nbsp; Are
              you sure you want to submit this <b>IPCR</b>?<br />
              <!-- Please note that
                <b>this action is irreversible.</b> -->
            </p>
          </div>
        </div>

        <!-- <v-card-title class="text-h5">
            Are you sure you want to proceed?
          </v-card-title> -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="confirmBtnLoading"
            color="red"
            outlined
            @click="cancelConfirm()"
          >
            Close
          </v-btn>
          <v-btn
            :disabled="confirmBtnLoading"
            :loading="confirmBtnLoading"
            color="green"
            class="white--text"
            @click="confirmSubmit()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- update data dialog -->
    <v-dialog
      v-model="editDataDialog"
      eager
      scrollable
      persistent
      max-width="800px"
      transition="dialog-bottom-transition"
    >
      <v-form ref="OPCRFormref" @submit.prevent>
        <v-card>
          <v-card-title dark class="dialog-header pt-5 pb-5 pl-6">
            <span>Update</span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="editDataDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 800px" class="my-4">
            <v-row>
              <v-col cols="12" class="mt-2">
                <v-textarea
                  color="#6DB249"
                  v-model="edit_actual_accomplishment"
                  :rules="[formRules.required]"
                  dense
                  outlined
                  label="Actual Accomplishment"
                  class="rounded-lg"
                >
                </v-textarea>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  outlined
                  :disabled="
                    tab == 1 ? dataToEdit && !dataToEdit.QT_is_rated : false
                  "
                  label="Quality"
                  dense
                  :rules="
                    tab == 1
                      ? dataToEdit && dataToEdit.QT_is_rated
                        ? [
                            formRules.numberNotAboveFiveOrBelowZero,
                            formRules.onlyNumberNoNegative,
                          ]
                        : []
                      : [
                          formRules.numberNotAboveFiveOrBelowZero,
                          formRules.onlyNumberNoNegative,
                        ]
                  "
                  type="number"
                  v-model="edit_quality"
                  class="rounded-lg"
                  color="#6DB249"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  outlined
                  :disabled="
                    tab == 1
                      ? dataToEdit && !dataToEdit.timeliness_is_rated
                      : false
                  "
                  label="Timeliness"
                  dense
                  :rules="
                    tab == 1
                      ? dataToEdit && dataToEdit.timeliness_is_rated
                        ? [
                            formRules.numberNotAboveFiveOrBelowZero,
                            formRules.onlyNumberNoNegative,
                          ]
                        : []
                      : [
                          formRules.numberNotAboveFiveOrBelowZero,
                          formRules.onlyNumberNoNegative,
                        ]
                  "
                  type="number"
                  v-model="edit_timeliness"
                  class="rounded-lg"
                  color="#6DB249"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="edit_remarks"
                  :rules="[formRules.required]"
                  dense
                  color="#6DB249"
                  outlined
                  label="Remarks"
                  class="rounded-lg"
                >
                </v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-5">
            <v-spacer></v-spacer>
            <v-btn color="red" outlined> Close </v-btn>
            <v-btn
              :loading="saveBtnLoading"
              :disabled="saveBtnLoading"
              @click="save()"
              color="#519043"
              class="white--text"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <AddAccomplishmentDialog :data="targetToView" :action="action" :tab="tab" />
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import icon from "@/assets/icon.vue";
export default {
  components: {
    AddAccomplishmentDialog: () =>
      import("../OPCR/AddAccomplishmentDialog.vue"),
    icon,
  },
  props: {
    data: null,
  },

  computed: {
    getSF1Len() {
      let len = 0;

      for (let i = 0; i < this.ipcrToView.data.sf1.data.length; i++) {
        if (this.ipcrToView.data.sf1.data[i].addToSF1Divisor) {
          len++;
        }
      }

      return len;
    },

    getIsPendingByApprovers() {
      return this.assessed_by_status == 3 || this.final_rating_by_status == 3;
    },

    getTotalCF() {
      let avgTemp = 0;
      let divisor = 0;
      let subT = 0;
      for (let i = 0; i < this.cf.length; i++) {
        if (this.cf[i].QL_is_rated) {
          subT += this.cf[i].efficiency_rate
            ? parseInt(this.cf[i].efficiency_rate)
            : 0;
          divisor++;
        }
        if (this.cf[i].QT_is_rated) {
          subT += this.cf[i].qly_rate ? parseInt(this.cf[i].qly_rate) : 0;
          divisor++;
        }
        if (this.cf[i].timeliness_is_rated) {
          subT += this.cf[i].timeliness_rate
            ? parseInt(this.cf[i].timeliness_rate)
            : 0;
          divisor++;
        }

        avgTemp += subT / divisor;
        subT = 0;
        divisor = 0;
      }
      return (avgTemp / this.getCFLength).toFixed(2);
    },

    getTotalSP() {
      let avgTemp = 0;
      for (let i = 0; i < this.sp.length; i++) {
        avgTemp +=
          (parseInt(this.sp[i].efficiency_rate) +
            parseInt(this.sp[i].qly_rate) +
            parseInt(this.sp[i].timeliness_rate)) /
          3;
      }
      return (avgTemp / this.getSPLength).toFixed(2);
    },

    getTotalSF() {
      let avgTemp = 0;
      for (let i = 0; i < this.sf.length; i++) {
        let divisor = 0;
        let subT = 0;
        if (this.sf[i].eff_is_rated) {
          subT += this.sf[i].efficiency ? parseInt(this.sf[i].efficiency) : 0;
          divisor++;
        }
        if (this.sf[i].qly_is_rated) {
          subT += this.sf[i].quality ? parseInt(this.sf[i].quality) : 0;
          divisor++;
        }
        if (this.sf[i].timeliness_is_rated) {
          subT += this.sf[i].timeliness ? parseInt(this.sf[i].timeliness) : 0;
          divisor++;
        }

        avgTemp += divisor != 0 ? subT / divisor : 0;
        subT = 0;
        divisor = 0;
      }
      return (avgTemp / this.getSFLength).toFixed(2);
    },

    getCFLength() {
      let cnt = 0;
      for (let i = 0; i < this.cf.length; i++) {
        if (
          !this.cf[i].QL_is_rated &&
          !this.cf[i].QT_is_rated &&
          !this.cf[i].timeliness_is_rated
        ) {
          cnt++;
        }
      }
      return this.cf.length - cnt;
    },

    getSPLength() {
      return this.sp.length;
    },

    getSFLength() {
      let cnt = 0;
      for (let i = 0; i < this.sf.length; i++) {
        if (
          !this.sf[i].eff_is_rated &&
          !this.sf[i].qly_is_rated &&
          !this.sf[i].timeliness_is_rated
        ) {
          cnt++;
        }
      }
      return this.sf.length - cnt;
    },
  },

  data() {
    return {
      remarksData: [],
      confirmSubmitDialog: false,
      confirmDialog: false,
      itemToDelete: null,
      confirmBtnLoading: false,
      options: {},
      action: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      mporData: [],
      dialog: false,
      activeTab: { id: 1, name: "Core Functions" },
      tab: 1,
      tabList: [
        { id: 1, name: "Core Functions" },
        { id: 2, name: "Strategic Priority" },
        { id: 3, name: "Support Functions" },
        { id: 4, name: "Category" },
      ],
      opcrData: null,
      targetToView: null,
      cf: [],
      sp: [],
      sf: [],
      ipcrToView: null,
      id: null,
      isSubmitted: null,
      dataItem: [],
      isButtonLoading: false,
      assessed_by: null,
      assessed_by_status: null,
      final_rating_by: null,
      final_rating_by_status: null,
      isEditing: false,
      editDataDialog: false,
      dataToEdit: null,
      edit_actual_accomplishment: null,
      edit_quality: null,
      edit_timeliness: null,
      edit_remarks: null,
      saveBtnLoading: false,
      headers: [
        {
          text: "MFO",
          value: "mfo",
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Efficiency",
          value: "efficiency",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Quality",
          value: "quality",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Timeliness",
          value: "timeliness",
          align: "center",
          valign: "center",
          sortable: false,
        },

        {
          text: "To be Rated",
          value: "eqt",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Action",
          value: "action",
          align: "end",
        },
      ],
      support_headers: [
        {
          text: "Type",
          value: "type",
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Success Indicator",
          value: "success_indicator",
          align: "center",
          width: 250,
          valign: "center",
          sortable: false,
        },

        {
          text: "To be Rated",
          value: "eqt",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Action",
          value: "action",
          align: "end",
        },
      ],
    };
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        this.activeTab = { id: 1, name: "Core Functions" };
        console.log("OPCR", data);
        this.id = data.id;
        this.assessed_by_status = data.assesed_by_status;
        this.final_rating_by_status = data.final_rating_by_status;
        this.isSubmitted = data.isSubmitted;
        this.tab = 1;
        this.initialize();
      },
      deep: true,
    },
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },

  mounted() {
    this.eventHub.$on("closeAddAccomplishmentDialog", () => {
      // this.initialize();
    });
  },

  beforeDestroy() {
    this.eventHub.$off("closeAddAccomplishmentDialog");
  },

  methods: {
    initialize() {
      this.loadRemarks(this.id);
      this.loading = true;
      this.axiosCall("/opcr/getOpcrBy/" + this.id, "GET").then((res) => {
        if (res) {
          console.log("oPCR", res.data);
          this.opcrData = res.data;
          this.cf = res.data.core_function;
          this.sp = res.data.strategic_priority;
          this.sf = res.data.support_function;
          //   if (this.tab != 4) {
          //     this.ipcrToView = res.data[this.tab - 1];
          //   }

          this.loading = false;
        }
      });

      //   this.axiosCall(
      //     "/ipcr/getIPCRApproverNames/" + this.id + "/IPCR",
      //     "GET"
      //   ).then((res) => {
      //     if (res) {
      //       console.log("signatorues", res.data);
      //       this.assessed_by = this.toTitleCase(res.data.assessed_by_name);
      //       // this.assessed_by_status = res.data.assesed_by_status;
      //       this.final_rating_by = this.toTitleCase(
      //         res.data.final_rating_by_name
      //       );
      //       // this.final_rating_by_status = res.data.final_rating_by_status;
      //     }
      //   });
    },

    printOPCR() {
      // alert(this.data.user_detailID);
      const url =
        process.env.VUE_APP_SERVER +
        "/pdf-generator/printOPCR/" +
        this.id +
        "/" +
        this.data.user_detailID;
      let token = localStorage.getItem("token");
      this.isLoading = true;
      const tab = window.open("about:blank");
      fetch(url, { headers: { Authorization: `Bearer ${token}` } }) // FETCH BLOB FROM IT
        .then((response) => response.blob())
        .then((blob) => {
          // RETRIEVE THE BLOB AND CREATE LOCAL URL
          var _url = window.URL.createObjectURL(blob);

          // window.open(_url, "_blank").focus();
          tab.location = _url;
          tab.focus();
          this.isLoading = false; // window.open + focus
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getCFSP_Avg(item) {
      if (this.tab == 1) {
        let divisor = 0;
        let subT = 0;
        if (item.QL_is_rated) {
          subT += item.efficiency_rate ? parseInt(item.efficiency_rate) : 0;
          divisor++;
        }
        if (item.QT_is_rated) {
          subT += item.qly_rate ? parseInt(item.qly_rate) : 0;
          divisor++;
        }
        if (item.timeliness_is_rated) {
          subT += item.timeliness_rate ? parseInt(item.timeliness_rate) : 0;
          divisor++;
        }

        return (subT / divisor).toFixed(2);
      } else {
        return (
          (parseInt(item.efficiency_rate) +
            parseInt(item.qly_rate) +
            parseInt(item.timeliness_rate)) /
          3
        ).toFixed(2);
      }
    },

    getSFAvg(item) {
      let divisor = 0;
      let subT = 0;
      if (item.eff_is_rated) {
        subT += item.efficiency ? parseInt(item.efficiency) : 0;
        divisor++;
      }
      if (item.qly_is_rated) {
        subT += item.quality ? parseInt(item.quality) : 0;
        divisor++;
      }
      if (item.timeliness_is_rated) {
        subT += item.timeliness ? parseInt(item.timeliness) : 0;
        divisor++;
      }

      if (
        !item.eff_is_rated &&
        !item.qly_is_rated &&
        !item.timeliness_is_rated
      ) {
        return "NR";
      } else {
        return subT / divisor;
      }
      // return "";
    },

    submitIPCR() {
      this.confirmSubmitDialog = true;
    },

    cancelConfirm() {
      this.confirmSubmitDialog = false;
    },

    // confirmSubmit() {
    //   this.confirmBtnLoading = true;
    //   this.axiosCall("/ipcr/submitMyIPCR/" + this.id, "PATCH").then((res) => {
    //     if (res.data.status == 200) {
    //       this.confirmBtnLoading = false;
    //       this.fadeAwayMessage.show = true;
    //       this.fadeAwayMessage.type = "success";
    //       this.fadeAwayMessage.header = "System Message";
    //       this.fadeAwayMessage.message = res.data.msg;
    //       this.closeD();
    //     } else if (res.data.status == 400) {
    //       this.fadeAwayMessage.show = true;
    //       this.fadeAwayMessage.type = "error";
    //       this.fadeAwayMessage.header = "System Message";
    //       this.fadeAwayMessage.message = res.data.msg;
    //     }
    //   });
    // },

    updateValue(tab, item) {
      console.log("OPCR TARGET ITEM", tab, item);
      // this.edit_actual_accomplishment = item.success_indicator_for_edit;
      // this.edit_quality = item.Q_rating;
      // this.edit_timeliness = item.T_rating;
      // this.edit_remarks = item.remarks;
      // this.dataToEdit = item;
      // this.editDataDialog = true;

      this.targetToView = item;
      //     this.opcrData = {
      //   targetType: this.tab,
      //   targetID:
      //     this.tab == 1 ? item.id : item.OpcrPapTargetDistributedTaggingID,
      //   opcrID: this.id,
      //   taggedTarget: item.target,
      //   QL_is_rated: this.tab == 1 ? item.QL_is_rated : true,
      //   timeliness_is_rated: this.tab == 1 ? item.timeliness_is_rated : true,
      //   Q_rating: item.Q_rating,
      //   T_rating: item.T_rating,
      //   success_indicator: item.success_indicator,
      //   efficiency: this.tab == 1 ? item.efficiency : item.tagged_target,
      //    attachment: item.accomplishments[0].attachment,
      // remarks: item.remarks,
      // };
      // this.action = "Add";
    },

    save() {
      this.saveBtnLoading = true;
      if (this.$refs.OPCRFormref.validate()) {
        let data = {
          targetID: this.dataToEdit.id,
          actual_accomplishment: this.edit_actual_accomplishment,
          quality: this.edit_quality,
          timeliness: this.edit_timeliness,
          remarks: this.edit_remarks,
          tab: this.tab,
        };
        console.log(this.dataToEdit, data);
        this.axiosCall("/opcr-target/save-edits/", "POST", data).then((res) => {
          if (res.data.status == 200) {
            this.confirmBtnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.dataToEdit = null;
            this.editDataDialog = false;
            this.saveBtnLoading = false;
            this.initialize();
            // this.closeD();
          } else if (res.data.status == 400) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.saveBtnLoading = false;
          }
        });
      }
    },

    loadRemarks(id) {
      if (id) {
        this.axiosCall("/remarks/" + id + "/IPCR", "GET").then((res) => {
          if (res.data) {
            console.log("remarks", res.data);
            this.remarksData = res.data;
          }
        });
      }
    },
    closeD() {
      if (this.isEditing) {
        this.isEditing = !this.isEditing;
      } else {
        this.eventHub.$emit("closeViewOPCRDialog", false);
        this.confirmSubmitDialog = false;
        this.dialog = false;
      }
    },
    edit(item) {
      if (this.tab != 3) {
        this.opcrData = item;
        this.action = "Update";
      } else {
        this.ipcrSupData = item;
        this.action = "Update";
      }
    },

    computeGeneralAve(data, percentage) {
      let avg = 0;
      if (percentage != 0) {
        if (data.data.length) {
          avg = ((data.total / data.data.length) * percentage).toFixed(2);
        } else {
          avg = (data.total * percentage).toFixed(2);
        }
        return avg;
      } else {
        return 0.0;
      }
    },

    // getOverAllrating() {
    //   let total = 0;
    //   for (let i = 0; i < this.opcrData.length; i++) {
    //     let d = this.computeGeneralAve(
    //       this.opcrData[i],
    //       this.opcrData[i].func_type != "Support Function"
    //         ? this.opcrData[i].func_type == "Core Function"
    //           ? this.opcrData[1].data.length > 0
    //             ? 0.6
    //             : 0.9
    //           : this.opcrData[1].data.length > 0
    //           ? 0.3
    //           : 0
    //         : 0.1
    //     );
    //     total += parseFloat(d);
    //   }
    //   return total.toFixed(2);
    // },

    changeTab(tab) {
      this.activeTab = tab;
      this.tab = tab.id;
      this.initialize();
    },
  },
};
</script>
<style scoped>
#ipcrTable,
#categoryTable {
  width: 100%;
  border-collapse: collapse;
}
#ipcrTable td,
#ipcrTable th,
#categoryTable td,
#categoryTable th {
  border: 1px solid grey;
}
</style>
